__turbopack_context__.v({
  "bottomInner": "heroAbout-module-scss-module__kkIEZq__bottomInner",
  "ctaWrapper": "heroAbout-module-scss-module__kkIEZq__ctaWrapper",
  "description": "heroAbout-module-scss-module__kkIEZq__description",
  "eyebrow": "heroAbout-module-scss-module__kkIEZq__eyebrow",
  "gradientText": "heroAbout-module-scss-module__kkIEZq__gradientText",
  "gradientZone": "heroAbout-module-scss-module__kkIEZq__gradientZone",
  "headline": "heroAbout-module-scss-module__kkIEZq__headline",
  "heroAbout": "heroAbout-module-scss-module__kkIEZq__heroAbout",
  "overlay": "heroAbout-module-scss-module__kkIEZq__overlay",
  "overlayBackdrop": "heroAbout-module-scss-module__kkIEZq__overlayBackdrop",
  "overlayClose": "heroAbout-module-scss-module__kkIEZq__overlayClose",
  "overlayIframe": "heroAbout-module-scss-module__kkIEZq__overlayIframe",
  "overlayPopup": "heroAbout-module-scss-module__kkIEZq__overlayPopup",
  "playButton": "heroAbout-module-scss-module__kkIEZq__playButton",
  "playIcon": "heroAbout-module-scss-module__kkIEZq__playIcon",
  "topInner": "heroAbout-module-scss-module__kkIEZq__topInner",
  "videoBackground": "heroAbout-module-scss-module__kkIEZq__videoBackground",
  "videoCard": "heroAbout-module-scss-module__kkIEZq__videoCard",
  "videoIframe": "heroAbout-module-scss-module__kkIEZq__videoIframe",
});
